import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-whats-app-community',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './whats-app-community.component.html',
  styleUrls: ['./whats-app-community.component.scss']
})
export class WhatsAppCommunityComponent {}
